<template>
	<page>
		<row class="mb-3">
			<v-col>
				<h2 class="text-right">
					{{ game.name }}
				</h2>
			</v-col>
			<c-col class="text-left">
				<router-link to="/games">
					<v-btn color="primary">
						<span v-if="isNew">סיימתי</span>
						<span v-else>סגור</span>
					</v-btn>
				</router-link>
			</c-col>
		</row>
		<v-expansion-panels
			v-model="openPanel"
			focusable
		>
			<v-expansion-panel>
				<v-expansion-panel-header>
					{{ actionTitle }} משחק
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<game-form @save="onSave" />
				</v-expansion-panel-content>
			</v-expansion-panel>

			<v-expansion-panel :disabled="isNew">
				<v-expansion-panel-header>
					{{ actionTitle }} שאלות
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<game-question-view />
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>
	</page>
</template>

<script>
import GameForm from "./GameForm";
import GameQuestionView from "../gameQuestions/GameQuestionView";
import GameModule from "../../store/modules/Game.module";

export default {
	name: "CreateGame",
	components: { GameQuestionView, GameForm },
	data () {
		return {
			openPanel: 0,
		};
	},
	computed: {
		game () {
			return this.$store.state.GameModule.game;
		},
		isNew () {
			return this.game.id === undefined;
		},
		actionTitle () {
			return this.isNew ? "הוספת" : "עריכת";
		},
	},
	async created () {
		const id = this.$route.params.id;
		if (id) {
			this.openPanel = 1;
		}
	},
	methods: {
		onSave (game) {
			this.$store.commit(GameModule.types.GET, game);
			this.openPanel = 1;
		},
	},
};
</script>

<style scoped>
</style>
